import * as angular from "angular";
import {IController} from "angular";

export class CommissionPanelComponent implements IController {

  commission: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('commissionPanel', {
    bindings: {
      commission: '<',
    },
    template: require('./commission-panel.html').default,
    controller: CommissionPanelComponent
  });
